var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "local_offer_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.79,
    height: 12.79,
    viewBox: "0 0 12.79 12.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38768",
    "data-name": "Path 38768",
    d: "M0,0H12.79V12.79H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38769",
    "data-name": "Path 38769",
    d: "M12.344,7.105l-4.8-4.8A1.059,1.059,0,0,0,6.8,2H3.066A1.069,1.069,0,0,0,2,3.066V6.8a1.063,1.063,0,0,0,.314.757l4.8,4.8a1.059,1.059,0,0,0,.751.309,1.042,1.042,0,0,0,.751-.314l3.73-3.73a1.042,1.042,0,0,0,.314-.751A1.076,1.076,0,0,0,12.344,7.105ZM7.862,11.6l-4.8-4.8V3.066H6.8V3.06l4.8,4.8Z",
    transform: "translate(-0.934 -0.934)",
    fill: "#747575"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_683",
    "data-name": "Ellipse 683",
    cx: 0.671,
    cy: 0.671,
    r: 0.671,
    transform: "translate(2.686 2.718)",
    fill: "#747575"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/Offer.b3e96ce53f54564ad8978cdc741e53ad.svg";
export { ForwardRef as ReactComponent };